//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { SocialMediaLinkType } from './Enums';

export class SocialMediaLinkInputItem extends ItemBase {
    SocialMediaType: SocialMediaLinkType = SocialMediaLinkType.Facebook;
    Url: string | null = null;

    constructor(initializer?: Partial<SocialMediaLinkInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "SocialMediaLinkInputItem";
}
